import { createContext, useContext, useState } from 'react';
import type { ShortcutGroup } from '../utils/pageShortcuts';

interface ShortcutsContextValue {
  dynamicGroups: ShortcutGroup[];
  setDynamicGroups: (groups: ShortcutGroup[]) => void;
}

const ShortcutsContext = createContext<ShortcutsContextValue>({
  dynamicGroups: [],
  setDynamicGroups: () => {},
});

export function useShortcutsContext() {
  return useContext(ShortcutsContext);
}

export function ShortcutsProvider({ children }: { children: React.ReactNode }) {
  const [dynamicGroups, setDynamicGroups] = useState<ShortcutGroup[]>([]);
  return (
    <ShortcutsContext.Provider value={{ dynamicGroups, setDynamicGroups }}>
      {children}
    </ShortcutsContext.Provider>
  );
}
